import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/acreditacion-contratistas/mine-pass")({
  head: () => ({
    meta: [
      { title: "Mine Pass | Acreditación Contratistas | Mine Class" },
      {
        name: "description",
        content:
          "Mine Pass: pasaporte digital de acreditación minera con IA. Centraliza documentos, valida cumplimiento y acelera el ingreso a faena.",
      },
      { property: "og:title", content: "Mine Pass | Acreditación Contratistas | Mine Class" },
      { property: "og:description", content: "Pasaporte digital con IA para acreditación de contratistas: documentos centralizados, cumplimiento validado, ingreso a faena más rápido." },
      { property: "og:url", content: "https://mine-class.com/soluciones/acreditacion-contratistas/mine-pass" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/acreditacion-contratistas/mine-pass" }],
  }),
  component: MinePassContent,
});

function MinePassContent() {
  return (
    <article className="space-y-6 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Pasaporte digital minero
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">
          Mine Pass
        </h2>
      </div>

      <p>
        Plataforma de gestión documental y acreditación minera que acelera el ingreso a faena hasta en un{" "}
        <strong>75%</strong>. Transforma un proceso tradicionalmente manual, burocrático y disperso en un
        flujo digital, automatizado y trazable.
      </p>
      <p>
        A través de un <strong>Pasaporte Digital interoperable</strong>, centraliza en un solo lugar la
        documentación habilitante de cada trabajador: contratos, cargos, cursos obligatorios, exámenes
        médicos y requisitos por faena.
      </p>
      <p>
        En el corazón de Mine Pass está <strong>VigIA</strong>, nuestra inteligencia artificial de
        validación documental, que analiza y verifica documentos automáticamente, detecta inconsistencias,
        identifica vencimientos y anticipa riesgos.
      </p>

      <div className="flex flex-wrap gap-2 pt-2">
        {["Pasaporte Digital", "IA VigIA", "-75% tiempos", "Interoperable"].map((f) => (
          <span
            key={f}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--color-brand-coral)]/10 text-[var(--color-brand-coral)] text-[11px] font-semibold"
          >
            <span className="material-symbols-outlined text-[13px]">check</span>
            {f}
          </span>
        ))}
      </div>

      <div className="pt-4">
        <a
          href="https://mine-pass.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Saber más
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </a>
      </div>
    </article>
  );
}
